import { useMutation } from '@tanstack/react-query';
import axios from '@/lib/axios';
import { Workspace } from '@/hooks/api/models';

/**
 * 0110. ワークスペース登録
 * [POST] /workspaces
 */
type Props = {
  name: string;
  identifier: string;
  closing_month: number;
  logo_image: string;
};
export const createWorkspace = (props: Props): Promise<Workspace> => {
  return axios.post(`/api/workspaces`, props);
};

export const useCreateWorkspace = () => {
  return useMutation({
    mutationFn: createWorkspace,
  });
};
